/* eslint-disable no-shadow */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getMultipleLists,
  MultipleListsView,
  resetFavorites,
  setMultiStepModalMode,
  setMultiStepModalOpenState,
} from '@resy/ui-kitchen';

import MultiStepListModal from '../../../../../ui-kitchen/src/components/MultiStepListModal';
import { MODAL_MODES } from '../../../../../ui-kitchen/src/reducers/favoriteSlice';
import { selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';
import Logger from '../../../../../ui-kitchen/src/utils/logger';

const MultipleListsContainer = ({
  $location,
  $rootScope,
  Analytics,
  isAuthenticated,
  lists,
  listsStatus,
  getMultipleLists,
  setMultiStepModalMode,
  setMultiStepModalOpenState,
  resetFavorites,
  userLocation,
}) => {
  const fetchMultipleLists = () => {
    getMultipleLists({
      lat: userLocation.lat,
      long: userLocation.long,
      limit: 100,
      offset: 0,
    });
  };
  useEffect(() => {
    const fetchData = () => {
      try {
        if (isAuthenticated) {
          resetFavorites();
          fetchMultipleLists();
        }
      } catch (err) {
        Logger.error('[MultipleListsContainer] Error saving favorite venue on mount', err);
      }
    };
    fetchData();
  }, [isAuthenticated]);

  const handleAddListClick = () => {
    setMultiStepModalMode(MODAL_MODES.CREATE_LIST);
    setMultiStepModalOpenState(true);
  };

  const handleListClick = (list) => {
    if (list.createdBy) {
      $location.path(`/account/lists/${list.urlSlug}/view`);
    } else {
      $location.path(`/account/lists/${list.listId}`);
    }
    Analytics.event('view list', {
      'shared list': false,
    });
    $rootScope.$digest();
  };

  return (
    <>
      <MultipleListsView
        lists={lists}
        onListClick={handleListClick}
        onAddListClick={handleAddListClick}
        isLoading={!listsStatus.loaded}
        isError={listsStatus.error.isError}
      />
      <MultiStepListModal Analytics={Analytics} />
    </>
  );
};

MultipleListsContainer.propTypes = {
  $location: PropTypes.shape({
    path: PropTypes.func,
  }).isRequired,
  $rootScope: PropTypes.shape({
    $digest: PropTypes.func,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  lists: PropTypes.arrayOf(PropTypes.shape({})),
  listsStatus: PropTypes.shape({
    error: PropTypes.shape({
      isError: PropTypes.bool,
    }),
    loaded: PropTypes.bool,
  }),
  getMultipleLists: PropTypes.func.isRequired,
  setMultiStepModalMode: PropTypes.func.isRequired,
  setMultiStepModalOpenState: PropTypes.func.isRequired,
  resetFavorites: PropTypes.func.isRequired,
  userLocation: PropTypes.shape({
    lat: PropTypes.number,
    long: PropTypes.number,
  }).isRequired,
};

MultipleListsContainer.defaultProps = {
  lists: [],
  listsStatus: {
    error: {
      isError: false,
    },
    loaded: false,
  },
};

const mapStateToProps = (state) => {
  const { favorite, user } = state;
  return {
    isAuthenticated: selectIsAuthenticated(state),
    lists: favorite.lists,
    listsStatus: favorite.listsStatus,
    userLocation: user.userLocation,
  };
};

const mapDispatchToProps = {
  getMultipleLists,
  setMultiStepModalMode,
  setMultiStepModalOpenState,
  resetFavorites,
};

MultipleListsContainer.displayName = 'MultipleListsContainer';
export { mapStateToProps, MultipleListsContainer as ComponentUnderTest };
export default connect(mapStateToProps, mapDispatchToProps)(MultipleListsContainer);
